import { ProjectFileFragment } from './project.fragment'
import { gql } from '@apollo/client'

export const ZoneFragmentProps = gql`
  fragment ZoneFragmentProps on Zone {
    id
    createdDate
    updatedDate
    parentId
    name
    description
    type
    index
  }
`

export const ZoneFragment = gql`
  fragment ZoneFragment on Zone {
    ...ZoneFragmentProps
    plans {
      ...ProjectFileFragment
    }
    children {
      ...ZoneFragmentProps
      plans {
        ...ProjectFileFragment
      }
      children {
        ...ZoneFragmentProps
        plans {
          ...ProjectFileFragment
        }
      }
    }
  }
  ${ZoneFragmentProps}
  ${ProjectFileFragment}
`
